// src/mocks/data/afipQueue.demo.js

export const health = {
    success: true,
    status: 'healthy',
    isHealthy: true,
    afip_connection: 'ok',
    queue_size: 0,
    last_check: '2026-01-13T10:00:00.000Z',
};

// Returned by /afip/queue/stats — component reads statsResult.data.data || statsResult.data.stats || statsResult.data
export const stats = {
    data: {
        pending:         0,
        processing:      1,
        failed_today:    0,
        completed_today: 8,
        total_today:     9,
    },
};

// Returned by /afip/queue/my-invoices — component reads invoicesResult.data.data || invoicesResult.data.invoices
export const myInvoices = {
    data: [
        { queueId: 8, external_reference: '20202732144-20260113-161802.2', client_name: 'RODRIGUEZ MARIO ALEJANDRO',      invoice_type: 'FACTURA B', invoice_amount:  6687.88, status: 'processing', created_at: '2026-01-13T16:18:04.623333', invoice_id: null  },
        { queueId: 7, external_reference: '20202732144-20260113-155900.6', client_name: 'CONSTRUCCIONES ALDABURU S.R.L.', invoice_type: 'FACTURA B', invoice_amount: 25402.31, status: 'approved',   created_at: '2026-01-13T15:59:02.390000', invoice_id: 6514 },
        { queueId: 6, external_reference: '20202732144-20260113-155750.0', client_name: 'GARCIA CLAUDIA BEATRIZ',         invoice_type: 'FACTURA B', invoice_amount:  3376.17, status: 'approved',   created_at: '2026-01-13T15:57:51.710000', invoice_id: 6512 },
        { queueId: 5, external_reference: '20202732144-20260112-153643.6', client_name: 'PINTURERIA EL ARCO IRIS S.A.S.', invoice_type: 'FACTURA A', invoice_amount: 24700.00, status: 'approved',   created_at: '2026-01-12T15:36:45.596666', invoice_id: 6508 },
        { queueId: 4, external_reference: '20202732144-20260110-152907.5', client_name: 'Consumidor Final',               invoice_type: 'FACTURA B', invoice_amount:  8841.47, status: 'approved',   created_at: '2026-01-10T15:29:09.673333', invoice_id: 6506 },
        { queueId: 3, external_reference: '20202732144-20260110-152835.1', client_name: 'FERNANDEZ HERNAN',               invoice_type: 'FACTURA B', invoice_amount: 12143.48, status: 'approved',   created_at: '2026-01-10T15:28:37.080000', invoice_id: 6505 },
        { queueId: 2, external_reference: '20202732144-20260108-152328.0', client_name: 'DISTRIBUIDORA COSTANERA',         invoice_type: 'FACTURA B', invoice_amount: 32847.73, status: 'approved',   created_at: '2026-01-08T15:23:29.993333', invoice_id: 6504 },
        { queueId: 1, external_reference: '20202732144-20260107-152256.9', client_name: 'TALLERES METALURGICOS VENTURA',  invoice_type: 'FACTURA A', invoice_amount: 94380.00, status: 'approved',   created_at: '2026-01-07T15:22:56.000000', invoice_id: 6503 },
    ],
};

// Legacy — kept for fallback
export const queue = { success: true, invoices: myInvoices.data };
